module.exports = __webpack_public_path__ + "img/pieceOneImg5.bb118f7.webp";